import React, { useContext } from 'react';
import { useQuery } from 'react-query';
import { AuthContext } from 'contexts/AuthContext';
import { FlashMessageContext } from 'contexts/FlashMessageContext';
import { FilterContext } from 'contexts/FilterContext';
import { SingleUserBlock } from 'common/SingleUserBlock';
import { LoadingSpinner } from 'common/LoadingSpinner';
import { getUserLabels } from 'utils/api/usersAPI';
import { UserLabelsList } from './UserLabelsList';
import { EmptyList } from './EmptyList';

export const UserLabels = () => {
    const { state, handleError } = useContext(AuthContext);
    const { addFlashMessage } = useContext(FlashMessageContext);
    const { userLabelFilters, setFiltersObject } = useContext(FilterContext);

    const { data, isLoading, refetch } = useQuery(['getUserLabels', state.isSingleUser], () => (!state.isSingleUser ? getUserLabels() : null), {
        onError: (err) => handleError(err),
    });

    return (
        <>
            {state.isSingleUser ? (
                <SingleUserBlock itemType="labels" />
            ) : isLoading ? (
                <LoadingSpinner />
            ) : data?.length > 0 ? (
                <UserLabelsList
                    labels={data}
                    refreshLabels={refetch}
                    handleError={handleError}
                    addFlashMessage={addFlashMessage}
                    setFiltersObject={setFiltersObject}
                    userLabelFilters={userLabelFilters}
                />
            ) : (
                <EmptyList refreshLabels={refetch} handleError={handleError} addFlashMessage={addFlashMessage} />
            )}
        </>
    );
};
